<template>
  <div class="content-block">
    <ResourceForm
      @done="onDone"
    ></ResourceForm>
  </div>
</template>

<script>
import ResourceForm from 'CORE/components/resource/form'

export default {
    name: 'ResourcesNewView',
    components: {
        ResourceForm,
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'resourcesList' })
        },
    },
}
</script>
